import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import Navbar from '../components/navbar';
import Footer from '../components/footer';
import { PageMeta } from '../seo/PageMeta';

const ERROR_CODES = [400, 401, 403, 404];

function ErrorContent({ code }) {
    const { t } = useTranslation('pages');
    const navigate = useNavigate();
    const errorKey = String(code);

    return (
        <div
            className="flex flex-column items-center justify-center py-96 pt-128 px-64 overflow-hidden w-full"
            data-navbar-theme="light"
        >
            <p className="text-title1 fustat t-blue text-bold m-0 text-center">
                {code}
            </p>
            <p className="text-title2 fustat t-graymain text-semibold m-0 mt-32 text-center w-80">
                {t(`errors.${errorKey}.title`)}
            </p>
            <p className="text-subtitle outfit t-graymid text-center mt-32 mb-64 m-0 w-80">
                {t(`errors.${errorKey}.description`)}
            </p>
            <div className="flex flex-column gap-32 items-center">
                <button
                    type="button"
                    onClick={() => navigate('/')}
                    className="btn-blue flex items-center justify-center gap-16"
                >
                    <span>{t('errors.backHome')}</span>
                    <FontAwesomeIcon icon={faAngleRight} />
                </button>
                <Link to="/nousjoindre" className="btn-link text-center">
                    {t('errors.contactUs')}
                </Link>
            </div>
        </div>
    );
}

export default function ErrorPage({ code = 404 }) {
    const { t } = useTranslation('pages');
    const safeCode = ERROR_CODES.includes(code) ? code : 404;
    const errorKey = String(safeCode);

    return (
        <>
            <PageMeta
                title={t(`meta.errors.${errorKey}.title`)}
                description={t(`meta.errors.${errorKey}.description`)}
                path={`/${safeCode}`}
                robots="noindex, nofollow"
                omitCanonical
            />
            <Navbar />
            <ErrorContent code={safeCode} />
            <Footer />
        </>
    );
}
